module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_SANTE_VERTE.7e3249ae.png";